import { render, staticRenderFns } from "./moveTreeData.vue?vue&type=template&id=ac3f1c82&"
import script from "./moveTreeData.vue?vue&type=script&lang=js&"
export * from "./moveTreeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports